// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__2vxhX","counter":"IconButton_counter__iyvBB","white":"IconButton_white__2FCRy","primary":"IconButton_primary__10dRi","black":"IconButton_black__15TP7"};